import { humanize } from "../../../../utils/utils";
import { IngredientDataTypeLabel } from "../../../../config/enums/IngredientType.enum";
import { SelectOption } from "../../ingredientRegister/types/ingredientRegisterView.types";

/**
 * Static-method formatting helpers for the read-only details view —
 * single-responsibility (label/text shaping only), mirroring
 * `IngredientRegisterOptions`'s convention. Looks up display text for a
 * stored id against the same option lists the register form uses
 * (`IngredientRegisterOptions.countries/produceTypes/farmingTypes/...`) so
 * "France"/"Cocoa" etc. render instead of a raw id.
 */
export class IngredientDetailsFormatter {
  static dataTypeLabel(dataType?: string): string {
    if (!dataType) return "";
    return IngredientDataTypeLabel[dataType as keyof typeof IngredientDataTypeLabel] || dataType;
  }

  static optionLabel(options: SelectOption[], value?: string | number | null): string {
    if (value === undefined || value === null || value === "") return "";
    return options.find(option => option.value === String(value))?.text || String(value);
  }

  static formatDateTime(value?: string | Date): string {
    if (!value) return "";
    try {
      return new Date(value).toISOString().slice(0, 19).replace("T", " ");
    } catch {
      return "";
    }
  }

  static humanizeKey(value: string): string {
    return humanize(value);
  }
}
